import PropTypes from 'prop-types';

import Typography from 'components/ui-kit/typography';
import Money from 'components/ui-kit/money';

import * as S from './styles';

const CreditSection = ({ creditApplied, amountAfterCredit }) => (
  <S.Box>
    <S.Row>
      <Typography color="dark" bold fluidFont={{ min: 12, max: 14 }}>
        Credit applied
      </Typography>

      <Typography color="dark" bold fluidFont={{ min: 12, max: 14 }}>
        <Money amount={-creditApplied} />
      </Typography>
    </S.Row>

    <S.Row>
      <Typography color="primary" fluidFont={{ min: 11, max: 13 }}>
        You will pay
      </Typography>

      <Typography color="primary" fluidFont={{ min: 11, max: 13 }}>
        <Money amount={amountAfterCredit} />
      </Typography>
    </S.Row>
  </S.Box>
);

CreditSection.propTypes = {
  creditApplied: PropTypes.number.isRequired,
  amountAfterCredit: PropTypes.number.isRequired,
};

export default CreditSection;
